"use client";

import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

type Props = {
  from: string;
  to: string;
  onFromChange: (v: string) => void;
  onToChange: (v: string) => void;
  className?: string;
};

export function DateRangePicker({
  from,
  to,
  onFromChange,
  onToChange,
  className,
}: Props) {
  return (
    <div className={`flex flex-wrap items-end gap-3 ${className ?? ""}`}>
      <div className="grid gap-1.5">
        <Label htmlFor="dr-from" className="text-xs">
          From
        </Label>
        <Input
          id="dr-from"
          type="date"
          value={from}
          onChange={(e) => onFromChange(e.target.value)}
          className="w-[160px]"
        />
      </div>
      <div className="grid gap-1.5">
        <Label htmlFor="dr-to" className="text-xs">
          To
        </Label>
        <Input
          id="dr-to"
          type="date"
          value={to}
          onChange={(e) => onToChange(e.target.value)}
          className="w-[160px]"
        />
      </div>
    </div>
  );
}
